import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { recentBuyers } from '../data/atlas';
export function PurchaseToast() {
  const [visible, setVisible] = useState(false);
  const [buyer, setBuyer] = useState(recentBuyers[0]);
  useEffect(() => {
    let hideTimer: ReturnType<typeof setTimeout>;
    const show = () => {
      setBuyer(recentBuyers[Math.floor(Math.random() * recentBuyers.length)]);
      setVisible(true);
      hideTimer = setTimeout(() => setVisible(false), 5000);
    };
    const first = setTimeout(show, 3000);
    const interval = setInterval(show, 15000);
    return () => {
      clearTimeout(first);
      clearTimeout(hideTimer);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-145" data-mp="f4vz05gx633m">
      {visible && <motion.div initial={{
      opacity: 0,
      x: 40,
      scale: 0.96
    }} animate={{
      opacity: 1,
      x: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      x: 40,
      scale: 0.96
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed right-3 top-3 z-50 w-[250px] sm:w-[270px]" role="status" aria-live="polite" data-id="element-146" data-mp="f3m2hkppt2z3">
          <div className="relative overflow-hidden rounded-lg border-2 border-teal bg-white p-2.5 pr-7 shadow-2xl" data-id="element-147" data-mp="238h8bpg4ki7l">
            <span className="absolute inset-x-0 top-0 h-1 bg-teal" aria-hidden="true" data-id="element-148" data-mp="285hdzz92biy6" />
            <button type="button" onClick={() => setVisible(false)} aria-label="Close notification" className="absolute right-1 top-1.5 text-slate2 transition-colors duration-150 hover:text-navy" data-id="element-149" data-mp="1bhkvgou2edkb">
              <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-150" data-mp="1p7oc90a6df2d" />
            </button>
            <div className="flex items-center gap-2.5" data-id="element-151" data-mp="rsajnlxfwcrh">
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-ice text-teal" data-id="element-152" data-mp="rrqzrzo8beat">
                <CheckCircle2Icon className="h-4 w-4" aria-hidden="true" data-id="element-153" data-mp="wor4a65fk8zt" />
              </span>
              <div className="leading-tight" data-id="element-154" data-mp="1zzwstyba3i7a">
                <p className="text-[13px] font-extrabold text-navy" data-id="element-155" data-mp="1v3pw8w4rvj20">{buyer.name}</p>
                <p className="text-[10px] font-semibold text-slate2" data-id="element-156" data-mp="28uuq1hlglh4f">{buyer.location}</p>
                <p className="mt-0.5 text-[11px] font-bold text-teal" data-id="element-157" data-mp="24szqahj6fbsr">
                  just purchased the VISUAL ATLAS™
                </p>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}